const BUS_EVENT = "yesbm:sse-notification";

// Lightweight in-app event bus for cross-component notifications.
// Using EventTarget avoids tying this to React context/state at the top-level.
const target =
  typeof window !== "undefined" && window.EventTarget
    ? new EventTarget()
    : null;

export const emitSseNotification = (payload) => {
  try {
    if (!target) return;
    target.dispatchEvent(new CustomEvent(BUS_EVENT, { detail: payload }));
  } catch {
    // no-op
  }
};

export const onSseNotification = (handler) => {
  if (!target || typeof handler !== "function") return () => {};
  const wrapped = (e) => handler(e?.detail);
  target.addEventListener(BUS_EVENT, wrapped);
  return () => target.removeEventListener(BUS_EVENT, wrapped);
};

